import { Ref, useCallback, useEffect, useRef, useState } from "react";

export function useBoundingClientRectRef<T extends HTMLDivElement>(): [
    DOMRect | undefined,
    Ref<T>
] {
    const onResizeRef = useRef<EventListener>();
    const [clientRect, setClientRect] = useState<DOMRect>();
    const ref = useCallback((element: HTMLDivElement | null) => {
        const onResize = () => {
            if (element) {
                setClientRect(element.getBoundingClientRect());
            }
        };

        onResizeRef.current = onResize;

        if (element) {
            onResize();
            window.addEventListener("resize", onResize);
        }
    }, []);

    useEffect(() => {
        const { current } = onResizeRef;
        return () => {
            if (current) {
                window.removeEventListener("resize", current);
            }
        };
    }, []);

    return [clientRect, ref];
}
